export let ExperimentKeys;

(function (ExperimentKeys) {
  ExperimentKeys["ONBF016"] = "onbf-016";
  ExperimentKeys["DIST008"] = "dist-008";
  ExperimentKeys["BIAB001"] = "biab-001";
  ExperimentKeys["ACQ117"] = "acq-117";
  ExperimentKeys["ACQ122"] = "acq-122";
  ExperimentKeys["ACQ111"] = "acq-111";
  ExperimentKeys["ACQ123"] = "acq-123";
})(ExperimentKeys || (ExperimentKeys = {}));

export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';